// use-cancel-subscription.ts — Subscription suite, action.

'use client';

import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { CancelSubscriptionResponse } from '@cabal/shared/domain/billing/subscription/types.js';
import { useApi } from '@/contexts/api';
import { currentUserKeys } from '@/contexts/current-user/keys';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';
import { subscriptionKeys } from './keys';

export function useCancelSubscription(): ActionResult<void, CancelSubscriptionResponse> {
  const api = useApi();
  const apiSubscription = api.subscription;
  const queryClient = useQueryClient();

  return useActionHook<void, CancelSubscriptionResponse>(
    useMemo(
      () => ({
        mutationFn: () => apiSubscription.cancel(),
        onInvalidate: () => {
          queryClient.invalidateQueries({ queryKey: subscriptionKeys.all });
          queryClient.invalidateQueries({ queryKey: currentUserKeys.all });
        },
      }),
      [apiSubscription, queryClient],
    ),
  );
}
